export const cssjs = (isResettingPassword) => ({
  display: isResettingPassword ? "none" : "flex",
});
